"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prettyDate = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _glamor = require("glamor");

var _ramda = require("ramda");

var R = _interopRequireWildcard(_ramda);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _redial = require("redial");

var _AppBox = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/AppBox");

var _AppBox2 = _interopRequireDefault(_AppBox);

var _MoviesBannerSlider = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/MoviesBannerSlider");

var _MoviesBannerSlider2 = _interopRequireDefault(_MoviesBannerSlider);

var _Section = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/Section");

var _Section2 = _interopRequireDefault(_Section);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _components = require("components");

var _news = require("redux/modules/news");

var _softwares = require("redux/modules/softwares");

var _utils = require("utils");

var _Content = require("@quixeltools/quixel-ui-library/dist/components/common/blog/Content");

var _Content2 = _interopRequireDefault(_Content);

var _cloudFront = require("../../utils/cloudFront");

var cf_utils = _interopRequireWildcard(_cloudFront);

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prettyDate = exports.prettyDate = function prettyDate(dateString) {
  return new Date(dateString).toLocaleString("en-us", {
    month: "long",
    day: "numeric",
    year: "numeric"
  });
};

var newHeroContainer = (0, _glamor.css)({
  display: "flex",
  justifyContent: "space-between",
  marginTop: "3px",
  marginBottom: "10px",
  height: "19vw"
}, (0, _css.maxWidth)(_css.breakpoints.xxxlarge)({
  marginBottom: "9px"
}), (0, _css.maxWidth)(_css.breakpoints.xxlarge)({
  marginBottom: "8px"
}), (0, _css.maxWidth)(_css.breakpoints.xlarge)({
  marginTop: "2px",
  marginBottom: "7px",
  height: "17vw"
}), (0, _css.maxWidth)(_css.breakpoints.large)({
  marginBottom: "0px",
  height: "18vw"
}), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  marginTop: "1px",
  flexDirection: "column",
  height: "auto"
}));

var _container = (0, _glamor.css)({
  flexWrap: "wrap",
  width: "100%",
  margin: "auto",
  justifyContent: "center",
  boxSizing: "border-box",
  textAlign: "center"
});
var smallHeading = (0, _glamor.css)(_fonts.superH2, {
  display: "flex",
  justifyContent: "center",
  textTransform: "uppercase",
  margin: "auto",
  paddingTop: "0.5rem",
  //paddingTop: '9rem',
  marginBottom: "2.125rem",
  //color: 'gray',
  textAlign: "center",
  color: _css.pallets.gray_text
});
var _heading = (0, _glamor.css)(_fonts.H2, {
  textTransform: "uppercase",
  display: "flex",
  justifyContent: "center",
  margin: "auto",
  marginBottom: "5.87rem",
  textAlign: "center",
  height: "auto",
  marginTop: "5.87",
  color: "#ffffff"
});

var bottomLink = (0, _glamor.css)({
  display: "flex",
  color: _css.pallets.gray_text,
  marginTop: "6.25rem",
  marginBottom: "2rem",
  textAlign: "center",
  justifyContent: "center"
}, (0, _css.maxWidth)(_css.breakpoints.xlarge)({
  marginLeft: "2rem"
}), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  marginTop: "2rem",
  marginLeft: "0"
}));

var main = (0, _glamor.css)({
  textAlign: "center",
  maxWidth: "100%",
  margin: "auto"
});

var blogContent = (0, _glamor.css)((0, _css.minWidth)(_css.breakpoints.mediumlarge)({
  flexBasis: "calc(33.33% - 10px)"
}));

var cloudfrontIcons = function cloudfrontIcons(path) {
  return __CLIENT__ ? "https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/" + path : "";
};
var cloudfrontImage = function cloudfrontImage(path) {
  return __CLIENT__ ? "https://d3uwib8iif8w1p.cloudfront.net/quixel/home/" + path : "";
};
var cloudfront = function cloudfront(path) {
  return "https://d3uwib8iif8w1p.cloudfront.net/megascans/icons/" + path;
};
var cloudfrontThumbs = function cloudfrontThumbs(path) {
  return "https://cdn.quixel.com/quixel/thumbs/" + path;
};

var listing = [{
  img: cf_utils.cf_qx_page("banner", "metro.jpg"),
  title: "games",
  description: "Craft rich, immersive environments in minutes. Indie team or AAA studio, our high-quality materials and powerful tools fit right into your workflow.",
  links: [{
    to: "#",
    label: "Business Licence"
  }, {
    to: "#",
    label: "Enterprise Licence"
  }, {
    to: "#",
    label: "Indie Developer Program"
  }]
}, {
  img: "https://s3-us-west-2.amazonaws.com/quixel-megascans-static/gallery/high/JungleBookElephantShot.jpg",
  title: "film & VFX",
  description: "Compose breathtaking scenes and effects with our industry-leading PBR scans, optimized for your production pipeline, for Oscar-winning results.",
  links: [{
    to: "#",
    label: "Business Licence"
  }, {
    to: "#",
    label: "Enterprise Licence"
  }]
}, {
  img: "https://d3uwib8iif8w1p.cloudfront.net/quixel/megascans/megascans-with-passion-for-your-industry.jpg",
  title: "ARCHVIZ",
  description: "Construct stunning, photorealistic interiors and exteriors with best-in-class PBR assets and tools for the architectural visualization space.",
  links: [{
    to: "#",
    label: "Architecture Licence"
  }]
}, {
  img: "https://d3uwib8iif8w1p.cloudfront.net/quixel/bridge/bridge-future-proof-your-pipeline.jpg",
  title: "automotive",
  description: "Turbocharge interactive models and animations with hyper-realistic materials and powerful tools in your automotive and product design productions.",
  links: [{
    to: "#",
    label: "Business Licence"
  }, {
    to: "#",
    label: "Enterprise Licence"
  }]
}];

var bannerListing = [cf_utils.cf_qx_page("banner", "black-panther.jpg"), cf_utils.cf_qx_page("banner", "COD.jpg"), cf_utils.cf_qx_page("banner", "american-gods.jpg"), cf_utils.cf_qx_page("banner", "metro.jpg"), cf_utils.cf_qx_page("banner", "justice-league.jpg"), cf_utils.cf_qx_page("banner", "destiny.jpg"), cf_utils.cf_qx_page("banner", "quixel_poster_mandalorian.jpg"), cf_utils.cf_qx_page("banner", "quixel_poster_cyberpunk.jpg"), cf_utils.cf_qx_page("banner", "lion-king-poster.jpg"), cf_utils.cf_qx_page("banner", "poster-village.jpg"), cf_utils.cf_qx_page("banner", "poster-lovedeath.jpg"), cf_utils.cf_qx_page("banner", "poster-demons-soul.jpg"), cf_utils.cf_qx_page("banner", "jumanji.jpg"), cf_utils.cf_qx_page("banner", "plague.jpg"), cf_utils.cf_qx_page("banner", "tomb-raider.jpg"), cf_utils.cf_qx_page("banner", "division.jpg"), cf_utils.cf_qx_page("banner", "jungle-book.jpg"), cf_utils.cf_qx_page("banner", "colossus.jpg"), cf_utils.cf_qx_page("banner", "anthem.jpg"), cf_utils.cf_qx_page("banner", "bfv.jpg")];

var toolTip = "\n  <div style=\"width:260px\">\n    <h1 style=\"letter-spacing: -0.5px;font-size: 18px;font-weight: 700;margin-bottom: 15px;color:#fff;font-family: 'Open Sans Condensed';letter-spacing: -0.5px;text-transform:uppercase\">Start your 30 day trial, free!</h1>\n    <ul>\n      <li style=\"display: flex;align-items: center;margin-bottom: 8px;\">\n        <svg style=\"position: relative;fill: #6F6F6F;display: inline-block;\" width=\"15\" height=\"15\" viewBox=\"0 0 33 33\"><path d=\"M16.5 33C7.402 33 0 25.598 0 16.5 0 7.402 7.402 0 16.5 0 25.598 0 33 7.402 33 16.5 33 25.598 25.598 33 16.5 33zm0-30C9.056 3 3 9.056 3 16.5S9.056 30 16.5 30 30 23.944 30 16.5 23.944 3 16.5 3zm9.394 9.561l-10 9.999a1.496 1.496 0 0 1-2.121 0l-5-4.999a1.5 1.5 0 0 1 2.121-2.122l3.939 3.94 8.94-8.94a1.501 1.501 0 0 1 2.121 2.122z\"></path></svg>        <p style=\"color:#6F6F6F;margin-left: 9px;display: inline-block;margin-top: 0px;font-size: 15px;line-height: 0;letter-spacing: -0.4px;\">Access free Megascans-assets</p>\n      </li>\n      <li style=\"display: flex;align-items: center;margin-bottom: 8px;\">\n        <svg style=\"position: relative;fill: #6F6F6F;display: inline-block;\" width=\"15\" height=\"15\" viewBox=\"0 0 33 33\"><path d=\"M16.5 33C7.402 33 0 25.598 0 16.5 0 7.402 7.402 0 16.5 0 25.598 0 33 7.402 33 16.5 33 25.598 25.598 33 16.5 33zm0-30C9.056 3 3 9.056 3 16.5S9.056 30 16.5 30 30 23.944 30 16.5 23.944 3 16.5 3zm9.394 9.561l-10 9.999a1.496 1.496 0 0 1-2.121 0l-5-4.999a1.5 1.5 0 0 1 2.121-2.122l3.939 3.94 8.94-8.94a1.501 1.501 0 0 1 2.121 2.122z\"></path></svg>        <p style=\"color:#6F6F6F;margin-left: 9px;display: inline-block;margin-top: 0px;font-size: 15px;line-height: 0;letter-spacing: -0.4px;\">Full-feature access to Quixel Mixer (Beta)</p>\n      </li>\n      <li style=\"display: flex;align-items: center;margin-bottom: 8px;\">\n        <svg style=\"position: relative;fill: #6F6F6F;display: inline-block;\" width=\"15\" height=\"15\" viewBox=\"0 0 33 33\"><path d=\"M16.5 33C7.402 33 0 25.598 0 16.5 0 7.402 7.402 0 16.5 0 25.598 0 33 7.402 33 16.5 33 25.598 25.598 33 16.5 33zm0-30C9.056 3 3 9.056 3 16.5S9.056 30 16.5 30 30 23.944 30 16.5 23.944 3 16.5 3zm9.394 9.561l-10 9.999a1.496 1.496 0 0 1-2.121 0l-5-4.999a1.5 1.5 0 0 1 2.121-2.122l3.939 3.94 8.94-8.94a1.501 1.501 0 0 1 2.121 2.122z\"></path></svg>        <p style=\"color:#6F6F6F;margin-left: 9px;display: inline-block;margin-top: 0px;font-size: 15px;line-height: 0;letter-spacing: -0.4px;\">Full-feature access to Quixel Bridge</p>\n      </li>\n    </ul>\n  </div> ";

var Home = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Home, _React$Component);

  function Home(props) {
    (0, _classCallCheck3.default)(this, Home);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call(this, props));

    _this.state = {
      platform: "Windows",
      variation: ""
    };
    _this.renderContactUsForm = _this.renderContactUsForm.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Home, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var platform = (0, _utils.detectOperatingSystem)();
      this.setState({
        platform: platform
      });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.props.loaded === false && nextProps.loaded === true || this.props.news !== nextProps.news || this.state.platform !== nextState.platform || this.props.loggedIn !== nextState.loggedIn) {
        return true;
      }

      return false;
    }
  }, {
    key: "renderContactUsForm",
    value: function renderContactUsForm(title, description, tag, initialValues) {
      this.context.dialogs.custom(_react2.default.createElement(_components.ContactUsPopupContainer, {
        title: title,
        description: description,
        tag: tag,
        initialValues: {
          name: R.propOr("", "name", initialValues),
          email: R.propOr("", "email", initialValues),
          subject: R.propOr("", "subject", initialValues),
          comment: R.propOr("", "comment", initialValues)
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          news = _props.news,
          user = _props.user;

      var blogPosts = news.blog.slice(0, 6);

      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "| 3D world-building made easy",
          documentImage: cloudfrontThumbs("page-thumb-quixel.jpg"),
          documentDescription: "Build detailed 3D worlds with 16,000+ high-quality 3D assets, a 3D content manager, and an easy-to-use texturing tool. All free for use with Unreal Engine." },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_components.Hero, {
            className: (0, _glamor.css)({ "& h3": { textTransform: "uppercase" } }),
            bg: cf_utils.cf_qx_page("home", "black.jpeg"),
            opacity: 0.25,
            backgroundVideo: {
              poster: cf_utils.cf_qx_page("home", "black.jpeg"),
              loop: "true",
              src: cf_utils.cf_qx_page("home", "fab-assets-logo-looped-webcompressed.mp4")
            },
            title: "ANNOUNCING A NEW CHAPTER</br>FOR QUIXEL",
            primaryLabel: "",
            primaryTo: "",
            linkIcon: "rightSide",
            secondaryLabel: "Read More",
            secondaryTo: "/blog/2023/3/22/announcing-a-new-chapter-for-quixel",
            onScrollDisable: true,
            artist: ""
          }),
          _react2.default.createElement(
            "div",
            { className: newHeroContainer },
            _react2.default.createElement(_AppBox2.default, {
              bg: cf_utils.cf_qx_page("home", "quixel-frontpage-card-ms.jpg"),
              superIconUrls: [cloudfrontIcons("megascans_icon_2048_preview.png")],
              title: "Megascans",
              subTitle: "The largest and fastest growing 3d scan library",
              to: "/megascans"
            }),
            _react2.default.createElement(_AppBox2.default, {
              bg: cf_utils.cf_qx_page("home", "quixel-frontpage-card-br.jpg"),
              superIconUrls: [cloudfrontIcons("bridge_icon_2048.png")],
              title: "Bridge",
              subTitle: "Your Gateway to Megascans AND Metahumans",
              to: "/bridge"
            }),
            _react2.default.createElement(_AppBox2.default, {
              bg: cf_utils.cf_qx_page("home", "productcard-frontpage-mixer.jpg"),
              superIconUrls: [cloudfrontIcons("mixer_icon_2048_preview.png")],
              title: "Mixer",
              subTitle: "TEXTURING MADE SIMPLE",
              to: "/mixer"
            })
          ),
          _react2.default.createElement(_components.VideoLinkSection, {
            typeLabel: "MEET THE APPS",
            YTid: "5ZjwwtMlNCU",
            bg: cloudfrontImage("Meet_the_apps_Thumbnail.jpg")
          }),
          _react2.default.createElement(_Section2.default, {
            mode: "dark",
            innerClassName: (0, _glamor.css)({ maxWidth: "100%", margin: "auto" }),
            content: _react2.default.createElement(_MoviesBannerSlider2.default, { title: "featured in", bannerListing: bannerListing })
          }),
          _react2.default.createElement(_Section2.default, {
            content: _react2.default.createElement(
              "div",
              { className: _container },
              _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "div",
                  { className: smallHeading },
                  "QUIXEL BLOG"
                )
              ),
              _react2.default.createElement(
                "div",
                { className: _heading },
                "The latest news and articles"
              ),
              _react2.default.createElement(_Content2.default, {
                className: blogContent,
                loaded: this.props.loaded,
                news: blogPosts,
                count: 6,
                isHome: true
              })
            ),
            footer: _react2.default.createElement(
              "div",
              { className: bottomLink },
              _react2.default.createElement(
                "span",
                { className: _fonts.p3 },
                _react2.default.createElement(_components.TextButtonLibrary, {
                  className: (0, _glamor.css)({ padding: 1 }, _fonts.p3),
                  mode: "normal-small",
                  to: "/blog",
                  label: "Go to blog."
                })
              )
            )
          }),
          _react2.default.createElement(_components.UnrealUnlimitedBanner, {
            title: "Unlimited Megascans access<br>for use with Unreal Engine",
            subTitle: "If you have a Content License, simply sign in with your Epic Games<br>account to get unlimited access to the Megascans library through Bridge.*",
            message: "*This Megascans access is licensed for use with Unreal Engine-based products only and treats Megascans<br>assets as Epic Games Content under the Content License Agreement.<br><br>",
            secondaryLabel: "Get started",
            user: user,
            backgroundVideo: {
              poster: cf_utils.cf_qx_page("home", "unlimitedaccess-loop-FALLBACK.jpg"),
              loop: "true",
              src: cf_utils.cf_qx_page("home", "unlimitedaccess-loop-compressed.mp4")
            },
            link: {
              label: "Learn More",
              to: _config2.default.forumBaseUrl,
              target: "_blank",
              rel: "noreferrer"
            }
          })
        )
      );
    }
  }]);
  return Home;
}(_react2.default.Component), _class.contextTypes = {
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = (0, _redial.provideHooks)({
  defer: function defer(_ref) {
    var dispatch = _ref.store.dispatch;

    var studio = dispatch((0, _softwares.loadMixerUpdater)());
    var news = dispatch((0, _news.loadNews)(1, 6));
    return _bluebird2.default.all([studio, news]);
  }
})((0, _reactRedux.connect)(function (state) {
  return {
    news: state.news,
    loaded: state.news.loaded,
    loggedIn: state.auth.loggedIn,
    softwares: state.softwares,
    variation: state.softwares.variation,
    subscription: state.user && state.user.subscription,
    user: state.user
  };
})(Home));


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/Home.jsx
// module id = 439
// module chunks = 0